import React from 'react';
import { Crosshair } from 'lucide-react';
import { favoredEnemyCastsLeft, favoredEnemyUses, getRangerLevel, hasRangerFeature } from '../../../shared/rules/ranger.mjs';

/**
 * Favored Enemy tile: casts the feature's free level 1 Hunter's Mark straight to targeting (no slot picker).
 * Slot casts of the always-prepared spell go through the spell list. The cast runs through BuffSpellControls.
 */
export default function FavoredEnemyControls({ form, characterId, combatState, isActiveTurn, blockReason, onCast }) {
  if (!hasRangerFeature(form, 'favoredEnemy')) return null;
  const maximum = favoredEnemyUses(getRangerLevel(form));
  const remaining = favoredEnemyCastsLeft(form);
  const inCombat = Number.isInteger(combatState?.activeTurn) && Boolean(combatState?.participants?.[combatState.activeTurn]);
  const ledger = combatState?.turnActionLedger?.combatantId === String(characterId) && combatState.turnActionLedger.turnSequence === combatState.turnSequence ? combatState.turnActionLedger : null;
  const available = remaining > 0 && !blockReason && (!inCombat || (isActiveTurn && !ledger?.bonusActionSpent));
  const title = blockReason || (remaining > 0
    ? "Favored Enemy · Hunter's Mark (level 1) · Bonus Action · no spell slot"
    : 'Favored Enemy · no casts left until a Long Rest');
  return (
    <button type="button" data-action-tile="favored-enemy" className="combat-hud-resource-tile combat-hud-feature-action-tile" style={{ '--hud-resource-accent': '#5fbf6a' }}
      title={title} aria-label={`Favored Enemy: ${remaining} of ${maximum} uses`} disabled={!available} onClick={() => onCast?.()}>
      <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Crosshair size={20} /></span>
      <span className="combat-hud-resource-tile__name">Favored Enemy</span>
      <span className="combat-hud-resource-tile__value">{remaining}/{maximum}</span>
    </button>
  );
}
